import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index.js'

const loadView = view =>
  () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'profiles',
        query: { initialPageLoad: 1 },
      }
    },
    {
      path: '/profiles/:slug',
      name: 'single_profiles',
      component: loadView('SingleProfile'),
      meta: { memberOnly: false }
    },
    {
      path: '/profiles',
      name: 'profiles',
      component: loadView('ProfilesArchive')
    },
    {
      path: '/awards',
      name: 'awards',
      component: loadView('Awards')
    },
    {
      path: '/awards/:id',
      name: 'single_awards',
      component: loadView('SingleAwards'),
      meta: { memberOnly: true }
    },
    {
      path: '/awards_results',
      name: 'awards_results',
      component: loadView('AwardsResults'),
      meta: { memberOnly: false }
    },
    {
      path: '/awards_results/:slug',
      name: 'single_awards_results',
      component: loadView('SingleAwardsResults'),
      meta: { memberOnly: false }
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: loadView('Reviews'),
      meta: { memberOnly: false }
    },
    {
      path: '/reviews/:id',
      name: 'single_reviews',
      component: loadView('SingleReviews'),
      meta: { memberOnly: false }
    },
    {
      path: '/disputes',
      name: 'disputes',
      component: loadView('Disputes'),
      meta: { memberOnly: false }
    },
    {
      path: '/disputes/:id',
      name: 'single_disputes',
      component: loadView('SingleDisputes'),
      meta: { memberOnly: false }
    },
    {
      path: '/payments',
      name: 'payments',
      component: loadView('Payments')
    },
    {
      path: '/stamps',
      name: 'stamps',
      component: loadView('Stamps'),
      meta: { memberOnly: true }
    },
    {
      path: '/partners',
      name: 'partners',
      component: loadView('Partners'),
      meta: { memberOnly: true }
    },
    {
      path: '/about',
      name: 'about',
      component: loadView('About')
    },
    {
      path: '/academy',
      name: 'academy',
      component: loadView('Academy'),
      meta: { memberOnly: true }
    },
    {
      path: '/lifeshare',
      name: 'lifeshare',
      component: loadView('Lifeshare')
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: loadView('MyAccount')
    },
    {
      path: '/retricted-content',
      name: 'retricted-content',
      component: loadView('MemberContent')
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.memberOnly)) {
    if (!store.state.user['is_active']) {
      next({
        path: '/retricted-content',
        query: { redirect: to.fullPath }
      })
    } else { next() }
  } else { next() }
})

export default router
